export type alarmStatusNames = "Healthy" | "Degraded" | "Critical" | "No data";

export enum StatusName {
  Healthy = "Healthy",
  Degraded = "Degraded",
  Critical = "Critical",
  NoData = "No data",
  Mitigated = "Mitigated",
}

export enum StatusColorName {
  Healthy = "GREEN",
  Degraded = "ORANGE",
  Critical = "RED",
}

export enum Colors {
  RED = "RED",
  MEDIUM_RED = "MEDIUM_RED",
  ORANGE = "ORANGE",
  GREEN = "GREEN",
  LOW_GRAY = "LOW_GRAY",
  CARBON_GRAY = "CARBON_GRAY",
  SILVER = "SILVER",
  PINK = "PINK",
  BLUE = "BLUE",
  LOW_BLUE = "LOW_BLUE",
  MEDIUM_BLUE = "MEDIUM_BLUE",
  LIGHT_YELLOW = "LIGHT_YELLOW",
}
